import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const MemberInterSubDepTransferCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? `لقد تم نقلك الى قسم فرعى جديد`
          : 'You have been moved to a new Sub-department'
      }
    />
  )
}

export default MemberInterSubDepTransferCover
